<!-- <marquee direction="left">
  This is a sample scrolling text that has scrolls texts to the left.
</marquee> -->
<div id="navbar-wrapper">
  <nav class="navbar navbar-inverse">
    <div class="container-fluid p-0">
      <div class="navbar-header">
        <h5 class="text-primary m-0">{{ pageTitle |async }}</h5>
        <!-- <a class="navbar-brand" id="sidebar-toggle" (click)="menuadd()"><img  loading="lazy"src="assets/images/menu-icon.png"></a> -->
      </div>
      <ul class="navbar-item ml-auto d-flex align-items-center list-none">
        <!-- <li class="mr-3">
          <div class="searchBox">
              <input class="searchInput"type="text" name="" placeholder="Search........">
              <button class="searchButton" href="#">
                <i class="fal fa-search"></i>
              </button>
          </div>
        </li> -->
        <li class="mr-3">
          <div class="notification dropdown dropdown-hover">
            <button
              class="btn"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
              routerLink="/notification"
            >
              <i class="icon-notification text-black"></i>
              <span class="badge-notification">{{ auth.countSignal() }}</span>
            </button>
        
          </div>
        </li>
        <li class="">
          <div class="profile dropdown dropdown-hover">
            <button class="btn custom-btn m-0 p-0 border-0" type="button" data-toggle="dropdown" aria-expanded="false">
              <span class="name-label">{{decData.details.fullname[0] | uppercase}}</span>
              <div class="pl-2 text-left m-0">
                <p class="text-primary m-0" for=""><strong>{{ decData.details.fullname }}</strong></p>
                <p class="d-block m-0">{{decData.details.username}}</p>
              </div>
              <i class="icon-down-arrow pl-1 ml-3"></i>
            </button>
            <div class="dropdown-menu p-0">
              <a class="dropdown-item" routerLink="account-settings" routerLink="/account-settings/Edit_Profile">
                <p class="m-0"><i class="icon-user mr-2 "></i>Profile</p>
              </a>
              <!-- <a class="dropdown-item" routerLink="/bankList">
                <p class="m-0"><i class="icon-bank mr-2 "></i>Bank List</p>
              </a> -->
              <a class="dropdown-item" (click)="logout()">
                <p class="m-0"><i class="icon-sign-out mr-2 "></i>Logout</p>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</div>